import React from 'react'
import Sidenav from './components/Sidenav'
import BusinessInfo from './components/BusinessInfo'
import RoleManagement from './components/RoleManagement'
import BankSettlement from './components/BankSettlement'
import UserManagement from './components/UserManagement'
import Cashback from './components/Cashback'
import Branches from './components/Branches'
import AccountSettings from './components/AccountSettings'
import POSManagement from './components/POSManagment'
import PermissionManagement from './components/PermissionManagement'
// import Categories from './components/Categories'
import Schedules from './components/Schedules'
import Contact from './components/ContactPerson'
import PaymentMethod from './components/PaymentMethod'
import { withRouter } from 'hooks/withRouter'

export default withRouter(function Settings({ router: { params: { name } } }) {

  const switcher = () => {
    switch (name) {
      case 'business-info':
        return <BusinessInfo />

      case 'contact-person':
        return <Contact />

      case 'role-management':
        return <RoleManagement />

      // case 'categories':
      //   return <Categories />
      case 'payment-mode':
        return <PaymentMethod />

      case 'settlement-bank':
        return <BankSettlement />

      case 'user-management':
        return <UserManagement />

      case 'pos-management':
        return <POSManagement />

      case 'permission-management':
        return <PermissionManagement />

      case 'cashback':
        return <Cashback />

      case 'branches':
        return <Branches />

      case 'schedules':
        return <Schedules />

      case 'account-settings':
        return <AccountSettings />

      default:
        return <></>
    }
  }

  return (
    <section className="w-full flex flex-col lg:flex-row gap-5">
      <aside className="bg-white p-5 rounded-xl w-[375px] h-[675px]">
        <Sidenav />
      </aside>

      <div className="w-full grow">
        {
          switcher()
        }
      </div>
    </section>
  )
})
